// extracted by mini-css-extract-plugin
export var copyableField = "_mo-4";
export var customerBadge = "_mo-0";
export var customerInfoTitle = "_mo-2";
export var details = "_mo-1";
export var dropdownContainer = "_mo-5";
export var dropdownImage = "_mo-6";
export var editAssigneeForm = "_mo-a";
export var editButton = "_mo-3";
export var email = "_mo-7";
export var hidden = "_mo-d";
export var input = "_mo-8";
export var saveButton = "_mo-b";
export var shopifyIcon = "_mo-c";
export var suggestionBadge = "_mo-e";
export var suggestionText = "_mo-f";
export var username = "_mo-9";